export default {
      id: "icon--close-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "sprite.svg#icon--close",
      toString: function () {
        return this.url;
      }
    }